import CpvReport from './CpvReport';
export default CpvReport;